import { logger } from 'cadenza/utils/logging';

const POPUP_DIMENSION_FACTOR =  0.8;

export function handleUrlAsPopup (url, { preferredWidth, preferredHeight }) {
  const { clientWidth, clientHeight } = document.getElementById('content');
  return import(/* webpackChunkName: 'legacy-dialog' */ 'cadenza/legacy-dialog/legacy-dialog')
    .then(({ showLegacyDialog }) => showLegacyDialog({
      url,
      width: calculateSize(clientWidth * POPUP_DIMENSION_FACTOR, preferredWidth),
      height: calculateSize(clientHeight, preferredHeight),
      closeable: true,
      resizeable: true
    }))
    .catch(error => logger.error('Failed to load legacy-dialog', error));
}

function calculateSize (maximalSize, preferredSize) {
  // only use preferredSize when enough space available
  if (typeof preferredSize === 'number' && (maximalSize >= preferredSize)) {
    return preferredSize;
  }
  return maximalSize;
}
